export default "__VITE_PUBLIC_ASSET__33946788__"